import React, { useState } from 'react';
import EmployeeList from './payroll/EmployeeList';
import ScheduleGrid from './payroll/ScheduleGrid';
import ScheduleOverview from './payroll/ScheduleOverview';
import PayrollSummary from './payroll/PayrollSummary';
import PayrollSettings from './payroll/PayrollSettings';
import { isAdmin } from './AdminDashboard';

const TABS = [
  { id: 'employees', emoji: '👥', label: '직원' },
  { id: 'schedule',  emoji: '📅', label: '입력' },
  { id: 'overview',  emoji: '📊', label: '전체 보기' },
  { id: 'summary',   emoji: '💰', label: '급여' },
  { id: 'settings',  emoji: '⚙️', label: '설정' },
];

export default function PayrollManager({
  employees = [], schedules = {}, payrollSettings = {},
  profitLoss = {},
  onEmployeesChange, onSchedulesChange, onSettingsChange,
  onProfitLossChange,
  canAccess, user,
}) {
  const [tab, setTab] = useState('employees');

  if (!canAccess('pro') && !isAdmin(user)) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexDirection: 'column', gap: '14px', padding: '40px', textAlign: 'center' }}>
        <div style={{ fontSize: '52px' }}>👥</div>
        <h2 style={{ fontSize: '20px', fontWeight: '800' }}>인건비 & 급여 관리</h2>
        <p style={{ color: '#6b7280', lineHeight: 1.7, maxWidth: '320px' }}>
          <strong>스탠다드 플랜</strong> 이상 전용 기능이에요.
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: '16px', maxWidth: '1100px', margin: '0 auto' }}>
      <div style={{ marginBottom: '16px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#18181B', margin: 0 }}>
          💼 인건비 & 급여 관리
        </h2>
        <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
          직원 등록 → 스케줄 입력 → 전체 보기 → 급여 자동 계산 + 손익관리 반영
        </p>
      </div>

      <div style={{ display: 'flex', gap: '4px', borderBottom: '1px solid #e5e7eb',
                    marginBottom: '16px', overflowX: 'auto' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: '10px 14px', cursor: 'pointer',
                     border: 'none', background: 'transparent',
                     fontSize: '13px', fontWeight: '700',
                     color: tab === t.id ? '#FF6F0F' : '#9ca3af',
                     borderBottom: tab === t.id ? '2px solid #FF6F0F' : '2px solid transparent',
                     whiteSpace: 'nowrap' }}>
            {t.emoji} {t.label}
          </button>
        ))}
      </div>

      {tab === 'employees' && (
        <EmployeeList employees={employees} onChange={onEmployeesChange} />
      )}
      {tab === 'schedule' && (
        <ScheduleGrid employees={employees} schedules={schedules} onSchedulesChange={onSchedulesChange} />
      )}
      {tab === 'overview' && (
        <ScheduleOverview employees={employees} schedules={schedules} />
      )}
      {tab === 'summary' && (
        <PayrollSummary
          employees={employees}
          schedules={schedules}
          settings={payrollSettings}
          profitLoss={profitLoss}
          onProfitLossChange={onProfitLossChange}
          user={user}
        />
      )}
      {tab === 'settings' && (
        <PayrollSettings settings={payrollSettings} onChange={onSettingsChange} />
      )}
    </div>
  );
}
